import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navigation from "./Navigation";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import "./styles/style.css";
import Analyzer from "./Analyzer";
import Home from "./Home";
import AboutUs from "./AboutUs";
import Vulnerability from "./Vulnerability";
import Contact from "./Contact";
function App() {
  return (
    <BrowserRouter>
      <video autoPlay muted loop id="video-background">
        <source src="/videoplayback.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Analyzer" element={<AnalyzerPage />} />
          <Route path="/Vulnerability" element={<Vulnerability />} />
          <Route path="/AboutUs" element={<AboutUs />} />
          <Route path="/Contact" element={<Contact />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

function AnalyzerPage() {
  return <Analyzer />;
}

export default App;
